import api from 'networkapp-api-connector';

export default {
    toggleFavorite: function (eventId, itemId, isFavorite = true) {
        return api.directory.toggleFavorite(itemId, isFavorite).then(() => {
            app.store.dispatch(
                app.actions.directory.singleDirectoryItemUpdate(eventId, {
                    id: itemId,
                    is_favorite: isFavorite,
                })
            );
        });
    },
};
